import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Form, Input, Popover, InputNumber, Icon } from "antd";

const reactStringReplace = require("react-string-replace");

const convertBasedOnLevel = require("../utilities/calc-stats");

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  componentDidMount() {
    if (this.props.editable) {
      document.addEventListener("click", this.handleClickOutside, true);
    }
  }

  componentWillUnmount() {
    if (this.props.editable) {
      document.removeEventListener("click", this.handleClickOutside, true);
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  handleClickOutside = (e) => {
    const { editing } = this.state;
    if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
      this.save();
    }
  };

  componentDidUpdate() {
    // const {
    //   editable,
    //   dataIndex,
    //   title,
    //   record,
    //   index,
    //   handleSave,
    //   ...restProps
    // } = this.props;
    // console.log(JSON.stringify(record));
    // console.log("componentdidupdate");
  }

  save = () => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  checkLevel = (rule, value, callback) => {
    if (value > 0) {
      callback();
      return;
    }
    callback("Level must be >0!");
  };

  render() {
    const { editing } = this.state;
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      ...restProps
    } = this.props;
    return (
      <td ref={(node) => (this.cell = node)} {...restProps}>
        {editable ? (
          <EditableContext.Consumer>
            {(form) => {
              this.form = form;
              return editing ? (
                <FormItem style={{ margin: 0 }}>
                  {form.getFieldDecorator(dataIndex, {
                    rules: [
                      {
                        validator: this.checkLevel,
                        type: "number",
                        required: true,
                      },
                    ],
                    initialValue: record[dataIndex],
                  })(
                    <Input
                      ref={(node) => (this.input = node)}
                      onPressEnter={this.save}
                    />
                  )}
                </FormItem>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  onClick={this.toggleEdit}
                >
                  {restProps.children}
                </div>
              );
            }}
          </EditableContext.Consumer>
        ) : (
          restProps.children
        )}
      </td>
    );
  }
}

class CompareTable extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      // {
      //   title: "No.",
      //   width: 70,
      //   align: "center",
      //   dataIndex: "number",
      //   key: "number",
      //   sorter: (a, b) => {
      //     var nameA = a.key.toUpperCase();
      //     var nameB = b.key.toUpperCase();
      //     if (nameA < nameB) {
      //       return -1;
      //     }
      //     if (nameA > nameB) {
      //       return 1;
      //     }
      //     return 0;
      //   }
      // },

      {
        title: (
          <div>
            <Popover
              trigger="click"
              placement="topLeft"
              content={
                <div onClick={(e) => e.stopPropagation()}>
                  Cat Levels: &nbsp;
                  <InputNumber
                    min={1}
                    max={999}
                    defaultValue={this.props.presetCatLevels}
                    size="small"
                    onChange={this.onInputNumberChange.bind(this)}
                  />
                </div>
              }
            >
              <Button style={{ padding: "0px 12px" }}>
                <Icon type="setting" />
              </Button>
            </Popover>
          </div>
        ),
        width: 57,
        dataIndex: "img",
        key: "img",
        fixed: "left",
        render: (text, record) => (
          // <a
          //   href={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          //   // target="_blank"
          // >
          <Link
            to={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          >
            <img
              src={
                "https://onestoppress.com/images/" +
                record.number +
                "_square.png"
              }
              alt={record.name}
            />
          </Link>
          // </a>
        ),
      },
      {
        title: "Name",
        width: 120,
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          // <a
          //   href={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          //   // target="_blank"
          // >
          <Link
            to={"/catinfo/" + record.number.slice(0, 3) + "/" + record.name}
          >
            {record.name}
          </Link>
          // </a>
        ),
      },
      {
        title: "Form",
        width: 100,
        dataIndex: "form",
        key: "form",
        render: (text, record) => (
          <Button
            // type="primary"
            style={{
              display: "block",
              width: "66px",
              paddingLeft: "8px",
              paddingRight: "8px",
            }}
            onClick={this.onChangeFormClick.bind(
              this,
              record.number,
              record.level2,
              record.key
            )}
          >
            {text}
          </Button>
        ),
        filters: [
          {
            text: "Normal",
            value: "Normal",
          },
          {
            text: "Evolved",
            value: "Evolved",
          },
          {
            text: "True",
            value: "True",
          },
          {
            text: "Ultra",
            value: "Ultra",
          },
        ],
        onFilter: (value, record) => record.form.indexOf(value) === 0,
      },
      {
        title: "Rarity",
        dataIndex: "rarity",
        key: "rarity",
        width: 100,
        filters: [
          {
            text: "Basic",
            value: "Basic",
          },
          {
            text: "Special",
            value: "Special",
          },
          {
            text: "Rare",
            value: "Rare",
          },
          {
            text: "Super",
            value: "Super",
          },
          {
            text: "Uber",
            value: "Uber",
          },
          {
            text: "Legendary",
            value: "Legendary",
          },
        ],
        onFilter: (value, record) => record.rarity.indexOf(value) === 0,
        // sorter: (a, b) => {
        //   var nameA = a.key.toUpperCase();
        //   var nameB = b.key.toUpperCase();
        //   if (nameA < nameB) {
        //     return -1;
        //   }
        //   if (nameA > nameB) {
        //     return 1;
        //   }
        //   return 0;
        // }
      },
      // {
      //   title: "Level",
      //   dataIndex: "level",
      //   key: "level",
      //   width: 100,
      //   align: "center"
      // },
      {
        title: "Level",
        dataIndex: "level2",
        key: "level2",
        width: 100,
        align: "center",
        editable: true,
        render(text) {
          return (
            <div style={{ textAlign: "center" }}>
              <span
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "4px",
                  padding: "4px 11px",
                  display: "block",
                }}
              >
                {text}
              </span>
            </div>
          );
        },
      },
      {
        title: "Health",
        dataIndex: "health2",
        key: "health2",
        width: 90,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.health
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.health
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.health;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "Damage",
        dataIndex: "damage2",
        key: "damage2",
        width: 100,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.damage
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.damage
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.damage;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
              {/* {typeof isCrazed} */}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "Range",
        dataIndex: "range",
        key: "range",
        width: 90,
        align: "center",
        sorter: (a, b) => a.range - b.range,
      },
      {
        title: "KB",
        dataIndex: "kb",
        key: "kb",
        width: 60,
        align: "center",
        sorter: (a, b) => a.kb - b.kb,
      },
      {
        title: "Speed",
        dataIndex: "speed",
        key: "speed",
        width: 90,
        align: "center",
        sorter: (a, b) => a.speed - b.speed,
      },
      {
        title: "DPS",
        dataIndex: "dps2",
        key: "dps2",
        width: 70,
        align: "center",
        sorter: (a, b) =>
          convertBasedOnLevel(
            a.rarity,
            a.level2,
            a.iscrazed,
            a.name.toLowerCase().includes("bahamut"),
            a.dps
          ) -
          convertBasedOnLevel(
            b.rarity,
            b.level2,
            b.iscrazed,
            b.name.toLowerCase().includes("bahamut"),
            b.dps
          ),
        render(text, record) {
          const type = record.rarity;
          const level = record.level2;
          const isCrazed = record.iscrazed;
          const stat = record.dps;
          const isBahamut = record.name
            .toLowerCase()
            .includes("Bahamut".toLowerCase());

          return (
            <div>
              {Math.round(
                convertBasedOnLevel(type, level, isCrazed, isBahamut, stat)
              )}
              {/* {typeof isCrazed} */}
            </div>
          );
          // return <div>{text}</div>;
        },
      },
      {
        title: "Target",
        dataIndex: "target",
        key: "target",
        width: 90,
        align: "center",
        filters: [
          {
            text: "Single",
            value: "Single",
          },
          {
            text: "Area",
            value: "Area",
          },
        ],
        onFilter: (value, record) => record.target.indexOf(value) === 0,
        // sorter: (a, b) => {
        //   var nameA = a.key.toUpperCase();
        //   var nameB = b.key.toUpperCase();
        //   if (nameA < nameB) {
        //     return -1;
        //   }
        //   if (nameA > nameB) {
        //     return 1;
        //   }
        //   return 0;
        // }
      },
      {
        title: "Time Between Attacks",
        dataIndex: "tba",
        key: "tba",
        width: 130,
        align: "center",
        sorter: (a, b) => a.tba - b.tba,
      },
      {
        title: "Atk. Animation",
        dataIndex: "anim",
        key: "anim",
        width: 110,
        align: "center",
        sorter: (a, b) => a.anim - b.anim,
      },
      {
        title: "Respawn Time",
        dataIndex: "spawn",
        key: "spawn",
        width: 96,
        align: "center",
        sorter: (a, b) => a.spawn - b.spawn,
      },
      {
        title: "Cost",
        dataIndex: "cost",
        key: "cost",
        width: 70,
        align: "center",
        sorter: (a, b) => a.cost - b.cost,
      },
      {
        title: "Enemy Types",
        dataIndex: "enemy",
        key: "enemy",
        width: 130,
        align: "center",
        filters: [
          {
            text: "Red",
            value: "red",
          },
          {
            text: "Floating",
            value: "floating",
          },
          {
            text: "Black",
            value: "black",
          },
          {
            text: "Metal",
            value: "metal",
          },
          {
            text: "Angel",
            value: "angel",
          },
          {
            text: "Alien",
            value: "alien",
          },
          {
            text: "Zombie",
            value: "zombie",
          },
          {
            text: "Relic",
            value: "relic",
          },
          {
            text: "Aku",
            value: "aku",
          },
          {
            text: "White",
            value: "white",
          },
        ],
        onFilter: function (value, record) {
          return record.ability.includes(
            record.ability.match(new RegExp(value)) !== null
              ? record.ability.match(new RegExp(value))[0]
              : "-1"
          );
        },
        render(text, record) {
          const enemylist = [
            "Red",
            "Floating",
            "Black",
            "Metal",
            "Angel",
            "Alien",
            "Zombie",
            "Relic",
            "Aku",
            "White",
          ];
          var enemy = "";
          const ability = record.ability;

          for (var i = 0; i < enemylist.length; i++) {
            if (ability.includes(enemylist[i].toLowerCase())) {
              if (enemy.length > 0) {
                enemy += ", " + enemylist[i];
              } else {
                enemy = enemylist[i];
              }
            }
          }

          return <div>{enemy}</div>;
        },
      },
      {
        title: "Ability",
        dataIndex: "ability",
        key: "ability",
        filters: [
          {
            text: "Attacks Only",
            value: "Attacks only",
          },
          {
            text: "Barrier Breaker",
            value: "Barrier Breaker",
          },
          {
            text: "Base Destroyer",
            value: "Base Destroyer",
          },
          {
            text: "Behemoth Slayer",
            value: "Behemoth Slayer",
          },
          {
            text: "Colossus Slayer",
            value: "Colossus Slayer",
          },
          {
            text: "Critical",
            value: "Critical",
          },
          {
            text: "Curse",
            value: "to curse",
          },
          {
            text: "Dodge",
            value: "Dodge",
          },
          {
            text: "Eva Angel Killer",
            value: "Eva Angel Killer",
          },
          {
            text: "Evade Surge",
            value: "Not(.*Surge)",
          },
          {
            text: "Extra Money",
            value: "money gained",
          },
          {
            text: "Freeze",
            value: "to freeze",
          },
          {
            text: "Immune to Curse",
            value: "Not(.*Curse)",
          },
          {
            text: "Immune to Toxic",
            value: "Not(.*Toxic)",
          },
          {
            text: "Insane Damage",
            value: "Insane Damage",
          },
          {
            text: "Insanely Tough",
            value: "Insanely Tough",
          },
          {
            text: "Knockback",
            value: "of knockback",
          },
          {
            text: "Long Distance",
            value: "Long Distance",
          },
          {
            text: "Massive Damage",
            value: "Massive Damage",
          },
          {
            text: "Is Metal",
            value: "Only takes 1",
          },
          {
            text: "Mini-Wave",
            value: "Mini-Wave",
          },
          {
            text: "Multi-hit Attack",
            value: "Multi-hit",
          },
          {
            text: "Omni Strike",
            value: "Omni Strike",
          },
          {
            text: "Resist Freeze",
            value: "Not(.*Freeze)",
          },
          {
            text: "Resist Knockback",
            value: "Not(.*Knockback)",
          },
          {
            text: "Resist Slow",
            value: "Not(.*Slow)",
          },
          {
            text: "Resist Weaken",
            value: "Not(.*Weaken)",
          },
          {
            text: "Resistant",
            value: "Resistant",
          },
          {
            text: "Savage Blow",
            value: "Savage Blow",
          },
          {
            text: "Shield Piercing",
            value: "Shield Piercing",
          },
          {
            text: "Slow",
            value: "to slow",
          },
          {
            text: "Strengthen",
            value: "Strengthen",
          },
          {
            text: "Strong",
            value: "Strong",
          },
          {
            text: "Surge Attacks",
            value: "Surge Attacks",
          },
          {
            text: "Survive",
            value: "Survive",
          },
          {
            text: "Unharmed by Waves",
            value: "Not(.*Wave)",
          },
          {
            text: "Warp Blocker",
            value: "Not(.*Warp)",
          },
          {
            text: "Wave Attack",
            value: "Wave attack",
          },
          {
            text: "Wave Shield",
            value: "Wave Shield",
          },
          {
            text: "Weaken",
            value: "to weaken",
          },
          {
            text: "Zombie Killer",
            value: "Zombie Killer",
          },
          {
            text: "Conjure",
            value: "Conjure",
          },
          {
            text: "Sage Slayer",
            value: "Sage Slayer",
          },
        ],
        onFilter: function (value, record) {
          return record.ability.match(new RegExp(value)) !== null;
        },
        render(text) {
          const formattedb = reactStringReplace(
            text,
            /b1(.+?)b2/g,
            (match, i) => <b key={"b" + i}>{match}</b>
          );
          const formattedu = reactStringReplace(
            formattedb,
            /u1(.+?)u2/g,
            (match, i) => <u key={"u" + i}>{match}</u>
          );

          return {
            props: {
              style: { whiteSpace: "pre-wrap" },
            },
            children: <div>{formattedu}</div>,
          };
        },
      },
      {
        title: "Delete",
        key: "operation",
        width: 60,
        align: "center",
        fixed: "right",
        render: (text, record) => (
          <Button
            shape="circle"
            icon="minus"
            onClick={this.onClick.bind(this, record.key)}
          />
        ),
      },
    ];
  }

  // onChange(filters, sorter) {
  //   console.log("params", filters, sorter);
  // }

  onClick = (key) => {
    // const selectedCats = [...this.props.selectedCats];
    // Pass deleted cat back to parent
    this.props.callbackFromParent(key);
    // console.log(key);
    // this.setState({ dataSource: dataSource.filter(item => item.key !== key) });
  };

  onChangeFormClick = (number, level2, key) => {
    this.props.formCallbackFromParent(number, level2, key);
  };

  // componentDidUpdate() {
  //   console.log("CompareTable: " + (this.props.viewportHeight - 200));
  // }

  handleSave = (row) => {
    const newData = [...this.props.selectedCats];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    // this.setState({ dataSource: newData });
    this.props.editableCallbackFromParent(newData);
  };

  onInputNumberChange(value) {
    if (value > 0 && value < 1000) {
      this.props.levelCallbackFromParent(value);
    }
  }

  render() {
    const dataSource = this.props.selectedCats;
    const innerHeight = this.props.viewportHeight;
    // const innerHeight = 200;

    const components = {
      body: {
        cell: EditableCell,
        row: EditableFormRow,
      },
    };
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <Table
        columns={columns}
        dataSource={dataSource}
        components={components}
        rowClassName={() => "editable-row"}
        scroll={{ x: 2000, y: innerHeight }}
        // onChange={this.onChange.bind(this)}
        size="small"
        loading={false}
        locale={{
          emptyText: (
            <div>
              Create and compare your own custom list of cats.
              <p></p>
              Adjust their forms and levels, and calculate stats for special
              cats, crazed cats, uber rare cats and more. Decide which cats to
              upgrade, and which cats to field in your lineup.
              <p></p>
              Start now by searching for the best battle cats!
            </div>
          ),
        }}
        pagination={{
          position: "bottom",
          hideOnSinglePage: true,
          showQuickJumper: true,
          showSizeChanger: true,
          defaultPageSize: 100,
          pageSizeOptions: ["25", "50", "100", "1500"],
        }}
      />
    );
  }
}

export default CompareTable;



// WEBPACK FOOTER //
// ./src/components/table/CompareTable.js